import {ICustomListData} from '../../interface/page/custom-list-data.interface';
import {DesignTypeEnum} from '../../enum/design-type.enum';
import {IBasePageData} from '../../interface/page/base-page-data.interface';

export function isCustomListInterface(page: IBasePageData): page is ICustomListData {
  return page.type === DesignTypeEnum.CustomList;
}
